import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import SeweragePipelinePopup from './SeweragePipelinePopup'
import { WardNameDataDDL } from '../../../../../../../Components/CommonDDL/WardNameDataDDL'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SeverageLocationDataDDL } from '../../../../../../../Components/CommonDDL/SeverageLocationDataDDL'
import { SeveragePipelineDetailsMasterDeleteAPI, SeveragePipelineDetailsMasterExportTableDataAPI, SeveragePipelineDetailsMasterTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeveragePipelineDetailsMaster'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../../Helper/Loading'
import { SeweragePipelineExportData } from './SeweragePipelineExportData'

export default function SeweragePipelineData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [ShowMap, setShowMap] = React.useState(false)
    const [LocationData, setLocationData] = React.useState({})
    const [isSearch, setIsSearch] = useState(false)

    const [YearValue, setYearValue] = useState(0)

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [SeverageLocation, setSeverageLocation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSewerageMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [SeverageLocation.ID, WardName.ID])

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setSeverageLocation({
            ...SeverageLocation,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_SW_PipelineDetailsID: item.m_sW_PipelineDetailsID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(SeveragePipelineDetailsMasterDeleteAPI({ data }))
    }

    useEffect(() => {
        const data = {

            M_SW_PipelineDetailsID: 0,
            M_WardID: WardName.ID,
            M_SW_LocationID: SeverageLocation.ID,
            PipelineDetail: '',
            M_UserID: UserID,
            From: From,
            To: To,
            token: token,
            handleSeveragePipelineDetailsMasterExport:handleSeveragePipelineDetailsMasterExport
            // M_GD_SectorID: SectorName.ID,
        }
        dispatch(SeveragePipelineDetailsMasterTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleSeveragePipelineDetailsMasterExport = () => {
        const data = {

            M_SW_PipelineDetailsID: 0,
            M_WardID: WardName.ID,
            M_SW_LocationID: SeverageLocation.ID,
            PipelineDetail: '',
            M_UserID: UserID,
            From: '1',
            To: '99999',
            token: token,
            // M_GD_SectorID: SectorName.ID,
        }
        dispatch(SeveragePipelineDetailsMasterExportTableDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.SeveragePipelineDetailsMasterTableData)
    const { ExportTableData, isExportLoading } = useSelector(state => state.SeveragePipelineDetailsMasterExportTableData)


    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {/* {isDeleteLoading && <Loading />} */}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className='data_mob'>
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-6'>
                                    <h5 className="ps-1 py-1 ">Pipelines Details Master</h5>
                                </div>
                                <div className='mar_add_minus'>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <SeweragePipelineExportData
                                                    ExcelData={ExportTableData}
                                                    name='Pipeline Details Master'
                                                // searchName={searchName}
                                                />
                                        }
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div>

                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-2 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12  ">
                                            <div className="row  rounded2">

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />

                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <SeverageLocationDataDDL
                                                        SeverageLocation={SeverageLocation}
                                                        setSeverageLocation={setSeverageLocation}
                                                        WardName={WardName}

                                                    />

                                                </div>

                                                <div className="col-12 col-lg-3 mt-lg-4" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-2">
                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Ward Name</th>
                                                            <th>Location</th>
                                                            <th>Pipeline Details</th>
                                                            <th className='action_icon action-col'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    <td className='min-w-75'>{item.swLocation ? item.swLocation : '-'}</td>
                                                                    <td className='int-val-col'>{item.pipelineDetail ? item.pipelineDetail : '-'}</td>
                                                                    <td style={{ textAlign: "center", }}>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div >
                {
                    SewerageMasterPopupShow ?
                        <SeweragePipelinePopup
                            open={SewerageMasterPopupShow}
                            popupHeading="Pipeline Details"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }

            </div >
        </>
    )
}
